import {isNotEmpty} from "./common";
import _ from 'lodash';

export const buildUrl = (path: string, params?: string) => {
  if(isNotEmpty(path) && isNotEmpty(params)) {
    return path + (_.startsWith(params, '?') ? '' : '?') + params;
  }
  return path;
};